// src/config.js
export const API_URL = 'https://fbapi.tdidigital.io';

export default { API_URL };